import React, { useState, useEffect } from "react";
import { useQueryParam, StringParam } from "use-query-params";
import { LoadingMessage } from "../../../components";

import { fetchTransactionDetails } from "../utils";
import Scene from "./Scene";
import {
  ActionPane,
  Footer,
  Header,
  Messages,
  SessionInfo,
} from "./components";
import { logger } from "../../../core";
import { jwtWatcher } from "../../../utils";
import { ErrorMessage, ERROR_CODES } from "../../../components";

const Session = () => {
  const [sessionID] = useQueryParam("sessionID", StringParam);
  const [gatewayName] = useQueryParam("gatewayName", StringParam);
  const [token] = useQueryParam("token", StringParam);
  const [isLoading, setLoading] = useState(true);
  const [hasError, setError] = useState(false);
  const [session, setSession] = useState({});
  const [errorName, setErrorName] = useState("");

  useEffect(() => {
    jwtWatcher.subscribe({
      token,
      onExpiry: () => setErrorName(ERROR_CODES.TIME_OUT),
    });

    const tryFetchTransaction = async () => {
      const { success, response } = await fetchTransactionDetails(
        token,
        sessionID,
        gatewayName
      );

      if (!success) {
        setError(true);
        setLoading(false);
        return;
      }

      setSession(response?.data);
      setLoading(false);
    };

    tryFetchTransaction();
  }, [token, sessionID, gatewayName]);

  const handleError = (code) => {
    logger.error(`Error in session outcome ${code}`);
    setError(true);
    setLoading(false);
  };

  if (isLoading) {
    return (
      <LoadingMessage message="Please wait while we process your request .." />
    );
  }

  if (errorName) {
    return (
      <>
        <Scene>
          <ErrorMessage
            type={errorName}
            additionalParams={{ urlCancel: session?.cancelURL }}
          />
        </Scene>
      </>
    );
  }

  return (
    <Scene>
      <Header
        gatewayName={gatewayName}
        status={session?.status}
        allowRetry={session?.allowRetry}
      />

      <Messages allowRetry={session?.allowRetry} hasError={hasError} />

      {!hasError && session?.allowRetry && (
        <Scene.FullWidth>
          <SessionInfo session={session} />
        </Scene.FullWidth>
      )}

      <Scene.FullWidth>
        <ActionPane
          token={token}
          sessionID={sessionID}
          gatewayName={gatewayName}
          cancelURL={session?.cancelURL}
          allowRetry={session?.allowRetry}
          onAction={() => setLoading(true)}
          onError={handleError}
        />
      </Scene.FullWidth>

      <Footer gatewayName={gatewayName} sessionID={sessionID} />
    </Scene>
  );
};

export default Session;
